import { createWebHashHistory, createRouter } from 'vue-router'

const routes = [
  { path: '/', component: () => import('../pages/home/home.vue') },
  {
    path: '/f',
    component: () => import('../pages/batch-fill/batch-fillstudent/batch-fillstudent.vue'),
  },
  {
    path: '/batch-delstudents',
    component: () => import('../pages/batch-fill/batch-delstudents/batch-delstudents.vue'),
  },
  {
    path: '/g',
    component: () => import('../pages/batch-fill/batch-filltimesfee/batch-filltimesfee.vue'),
  },
  {
    path: '/h',
    component: () => import('../pages/batch-fill/batch-filldatefee/batch-filldatefee.vue'),
  },
  {
    path: '/chargecard',
    component: () =>
      import('../pages/batch-fill/batch-fillchargecard/batch-fillchargecard.vue'),
  },
  {
    path: '/c',
    component: () => import('../pages/detail-report/course-fee/index.vue'),
  },
  {
    path: '/s',
    component: () => import('../pages/detail-report/student-sign/index.vue'),
  },
  {
    path: '/d',
    component: () => import('../pages/detail-report/student-sign/index-date.vue'),
  },
  {
    path: '/t',
    component: () => import('../pages/detail-report/teacher-perf/index.vue'),
  },
  {
    path: '/td',
    component: () => import('../pages/detail-report/teacher-perf/index-date.vue'),
  },
  {
    path: '/pouch',
    component: () => import('../pages/detail-report/pouch-records/pouch-records.vue'),
  },
  // 不用翻译
  {
    path: '/xiaoxx-admin',
    component: () => import('../pages/xiaoxx-admin/index.vue'),
  },
  {
    path: '/xiaoxx-admin-live',
    component: () => import('../pages/xiaoxx-admin/live.vue'),
  },
  {
    path: '/xiaoxx-admin-customer-manage',
    component: () => import('../pages/xiaoxx-admin/customer-manage.vue'),
  },
  {
    path: '/xiaoxx-admin-device-manage',
    component: () => import('../pages/xiaoxx-admin/device-manage.vue'),
  },
  {
    path: '/permission-setting',
    component: () => import('../pages/permission-setting/index.vue'),
  },
  {
    path: '/permission-person',
    component: () => import('../pages/permission-setting/person.vue'),
  },
  // 不用翻译 end
  {
    path: '/operation-records',
    component: () => import('../pages/operation-records/operation-records.vue'),
  },
  {
    path: '/paper-records',
    component: () => import('../pages/paper-records/paper-records.vue'),
  },
  {
    path: '/correction-manage',
    component: () => import('../pages/correction-manage/index.vue'),
  },
  // 朋阳 工资
  {
    path: '/employee',
    component: () => import('../pages/salary/employee.vue'),
  },
  // 销售人员业绩报表
  {
    path: '/sales-perf',
    component: () => import('../pages/salary/salary-report.vue?_t=1'),
  },
  // 老师托管业绩报表
  {
    path: '/teacher-perf',
    component: () => import('../pages/salary/salary-report.vue?_t=2'),
  },
  // 老师上课业绩报表
  {
    path: '/teacher-classes',
    component: () => import('../pages/salary/salary-report.vue?_t=5'),
  },
  // 经办人业绩表
  {
    path: '/handler-perf',
    component: () => import('../pages/salary/salary-report.vue?_t=6'),
  },
  // 工资汇总表
  {
    path: '/salary-all',
    component: () => import('../pages/salary/salary-report.vue?_t=3'),
  },
  // 工资条
  {
    path: '/salary-records',
    component: () => import('../pages/salary/salary-report.vue?_t=4'),
  },
  {
    path: '/salary-manage',
    component: () => import('../pages/salary-manage/index.vue'),
  },
  {
    path: '/salary-detail',
    component: () => import('../pages/salary-manage/salary-detail/index.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
